import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { DailyIssueChequeService } from "src/app/services/autopac-reports/daily-issue-cheque.service";

@Component({
  selector: "daily-issue-cheque",
  templateUrl: "./daily-issue-cheque.component.html",
  styleUrls: ["./daily-issue-cheque.component.css"],
})
export class DailyIssueChequeComponent implements OnInit {
  faPrint = faPrint;
  faEraser = faEraser;

  lockBtn = true;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private DailyIssueChequeService: DailyIssueChequeService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
    if (
      this.getFieldValue("FromDate") &&
      this.getFieldValue("ToDate")
    ) {
      this.lockBtn = false;
    } else {
      this.lockBtn = true;
    }
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "date",
        id: "FromDate",
        label: "From Date (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "date",
        id: "ToDate",
        label: "To Date (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "select",
        id: "Type",
        label: "Bank",
        options: [
          {
            value: "MAY BANK",
            display: "MAY BANK",
          },
          {
            value: "DBS BANK",
            display: "DBS BANK",
          },
          {
            value: "BOTH",
            display: "BOTH",
          },
        ],
        value: "MAY BANK",
      },
      {
        type: "select",
        id: "Format",
        label: "Select format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.DailyIssueChequeService.GetDataDailyIssueChequeReport(
      searchData,
    ).subscribe({
      next: (response) => {
        if (this.getFieldValue("Format") == "pdf") {
          window.open(response.body.Name, "_blank");
        } else if (this.getFieldValue("Format") == "excel") {
          window.open(response.body.Value, "_blank");
        } else if (this.getFieldValue("Format") == "both") {
          window.open(response.body.Value, "_blank");
          window.open(response.body.Name, "_blank");
        }
      },
      error: (error) => {
        console.log(error);
        this.handleError("Error getting data", error);
      },
    });
  }

  clear(): void {
    this.form[0].value = undefined;
    this.form[1].value = undefined;
    this.form[2].value = "MAY BANK";
  }

  private populateSearchBody(): any {
    return {
      FromDate: formatDate(
        this.getFieldValue("FromDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
      ToDate: formatDate(
        this.getFieldValue("ToDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
      Type: this.getFieldValue("Type"),
    };
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }
}
